import * as React from 'react';
import { Code } from 'react-content-loader';

function PreloaderCard() {
  return (
    <div className="card card--pathway">
      <div className="preloader-image">
        <div className="mb-2"><Code/></div>
      </div>
      <div className="card__content">
        <div className="mb-3"><Code/></div>
        <div className="mb-3"><Code/></div>
        <div className="mb-2"><Code/></div>
        <div className="mb-2"><Code/></div>
      </div>
    </div>
  );
}

export default function Preloader() {
  return (
    <div className="nv-learning-pathway-collection nv-learning-pathway-collection--preloader">
      <div className="container pathways-cards">
        <div className="row">
          <div className="col-lg-12">
            <div className="col cards-grid">
              <PreloaderCard/>
              <PreloaderCard/>
              <PreloaderCard/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
